import { IKakaoPayBookInfo } from "./book.types";

export class KakaoPayBookInfo implements IKakaoPayBookInfo {
  readonly id: string;
  readonly totalAmount: number;
  readonly mobileRedirectUrl: string;
  readonly pcRedirectUrl: string;

  constructor(data: IKakaoPayBookInfo) {
    this.id = data.id;
    this.totalAmount = data.totalAmount;
    this.mobileRedirectUrl = data.mobileRedirectUrl;
    this.pcRedirectUrl = data.pcRedirectUrl;
  }
}
